import { round } from "lodash"

interface durationInterface {
  unit: string
  amount: number
}

export const formatDuration = (
  duration: durationInterface | null,
  formatMessage: (messageDescriptor: object, values: object) => string
): string | null =>
  duration
    ? formatMessage(
        {
          id: `type.duration.${duration.unit}`,
          defaultMessage: "{amount, number} {amount, plural, one {Unit} other {Units}}",
        },
        { amount: round(duration.amount, 2) }
      )
    : null

export const formatDurationShort = (
  duration: durationInterface | null,
  formatMessage: (messageDescriptor: object, values: object) => string,
  precision = 2
): string | null =>
  duration
    ? formatMessage(
        {
          id: `type.duration.short.${duration.unit}`,
          defaultMessage: "{amount, number} {amount, plural, one {Unit} other {Units}}",
        },
        { amount: round(duration.amount, precision) }
      )
    : null
